import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import onClickOutside from 'react-onclickoutside';

import itemsStyles from '../SurveyPartItems/surveyPartItems.module.css';
import styles from './addElementMenu.module.css';

import { questionTypeValues, staticTextTypeValues } from '../../../../constants/types';

class AddElementMenu extends Component {
  constructor(props) {
    super(props);

    this.onClickAddElement = this.onClickAddElement.bind(this);
    this.toggle = this.toggle.bind(this);

    this.state = {
      isOpen: false
    };
  }

  // Used by onClickOutside
  handleClickOutside() {
    this.setState({
      isOpen: false
    });
  }

  onClickAddElement(elementType) {
    return () => {
      this.setState({ isOpen: false });
      this.props.addElement(elementType);
    };
  }

  toggle() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen
    }));
  }

  render() {
    const dropdownVisible = this.state.isOpen ? styles.open : '';

    return (
      <div>
        <div className={`${itemsStyles.header} ${itemsStyles.addElementHeader}`}>
          <button type="button" onClick={this.toggle} data-cy="survey-schema-part-add-element-button">
            <Translate id="surveyParts.addElement" /> +
          </button>
        </div>
        <ul className={`${styles.addElementDropdown} ${dropdownVisible}`} data-cy="survey-schema-part-add-element-menu">
          <li>
            <button type="button" onClick={this.onClickAddElement(staticTextTypeValues.HEADING)}>
              <span className="icon iconText">
                <Translate id="surveyParts.itemTitles.heading" />
              </span>
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={this.onClickAddElement(staticTextTypeValues.INSTRUCTION_TEXT)}
            >
              <span className="icon iconText">
                <Translate id="surveyParts.itemTitles.instructionText" />
              </span>
            </button>
          </li>
          <li>
            <button type="button" onClick={this.onClickAddElement(questionTypeValues.TEXT_FIELD)}>
              <span className="icon iconText">
                <Translate id="surveyParts.itemTitles.textField" />
              </span>
            </button>
          </li>
          <li>
            <button type="button" onClick={this.onClickAddElement(questionTypeValues.DROPDOWN)}>
              <span className="icon iconDropdown">
                <Translate id="surveyParts.itemTitles.dropdown" />
              </span>
            </button>
          </li>
          <li>
            <button type="button" onClick={this.onClickAddElement(questionTypeValues.LIKERT)}>
              <span className="icon iconLikert">
                <Translate id="surveyParts.itemTitles.likert" />
              </span>
            </button>
          </li>
          <li>
            <button type="button" onClick={this.onClickAddElement(questionTypeValues.RADIO_BUTTON_GROUP)}>
              <span className="icon iconRadio">
                <Translate id="surveyParts.itemTitles.radioButtonGroup" />
              </span>
            </button>
          </li>
          <li>
            <button type="button" onClick={this.onClickAddElement(questionTypeValues.CHECKBOX_GROUP)}>
              <span className="icon iconCheck">
                <Translate id="surveyParts.itemTitles.checkboxGroup" />
              </span>
            </button>
          </li>
        </ul>
      </div>
    );
  }
}

const { func } = PropTypes;
AddElementMenu.propTypes = {
  addElement: func.isRequired
};

export default onClickOutside(AddElementMenu);
